export default {
  strict: true,
  namespaced: true,
  state: {
    country: 'US',
    city: {
      country: '',
      list: []
    },
    location: {
      list: [],
      selected: null,
      loading: false
    },
    date: {
      show: false,
      start: null,
      end: null
    },
    roomCount: 1,
    childAge: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    list: [],
    filter: {
      sort: 'lowToHigh',
      star: [],
      amenities: []
    },
    selected: '',
    view: null,
    rooms: {
      data: '',
      selected: ''
    },
    block: '',
    commit: ''
  },
  mutations: {
    setData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
    setCityData (state, data) {
      for (let field in data) {
        state.city[field] = data[field]
      }
    },
    setLocationData (state, data) {
      for (let field in data) {
        state.location[field] = data[field]
      }
    },
    setDateData (state, data) {
      for (let field in data) {
        state.date[field] = data[field]
      }
    },
    setFilterData (state, data) {
      for (let field in data) {
        state.filter[field] = data[field]
      }
    },
    toggleStar (state, value) {
      let i = state.filter.star.indexOf(value)
      if (i > -1) state.filter.star.splice(i, 1)
      else state.filter.star.push(value)
    },
    toggleFilterCategory (state, value) {
      let i = state.filter.categories.indexOf(value)
      if (i > -1) state.filter.categories.splice(i, 1)
      else state.filter.categories.push(value)
    },
    setRoomsData (state, data) {
      for (let field in data) {
        state.rooms[field] = data[field]
      }
    },
    setBlockData (state, data) {
      for (let field in data) {
        state.block[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/hotel/index.js